module.exports = __webpack_public_path__ + "static/img/zhongBottomNew2.6652add.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhongBrand/zhongBottomNew2.png
// module id = M0F9
// module chunks = 0